import React from 'react';
import PropTypes from 'prop-types';

function TableBody({ children }) {
  return <tbody className="align-top bg-white">{children}</tbody>;
}

TableBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export { TableBody };
